import AbstractShape from "@/Models/Shapes/AbstractShape";
import { PreviewShapeFactory } from "@/Models/Shapes/PreviewShapeFactory";
import ShapeConfigurationFactory from "@/Models/ShapeConfigurations/ShapeConfigurationFactory";
import { convertUnits } from "@/functions/numbers";

export default {
	namespaced: true,
	getters: {
		getInstance: ( state, getters, rootState, { measurements } ): AbstractShape => {
			return ( new PreviewShapeFactory() ).get( {
				shape: 'kite',
				dimensions: measurements.dimensions,
				modifiers: measurements.modifiers,
			} );
		},
		cutoutPrimitives: ( state, getters, rootState, { cutoutMeasurements } ): object => {
			return convertUnits( cutoutMeasurements.dimensions[ 'kite' ] );
		},
		getCutoutArea: ( state, getters, rootState, { cutoutMeasurements, getArea } ): number => {
			return getArea( 'kite', cutoutMeasurements.dimensions[ 'kite' ] );
		},
		isCenteredShape: (): boolean => true,
		getArea: ( state, getters, rootState, { getArea, parsedDimensions } ): object => {
			return getArea( 'kite', parsedDimensions );
		},
	},
};
